import React, { useEffect, useState } from "react";
import { Tab, Box, Divider, Grid, InputLabel, Avatar, Typography, Dialog, DialogTitle, DialogContent, useTheme } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import SearchIcon from "@mui/icons-material/Search";
import PaymentIcon from "@mui/icons-material/Payment";
import PaperCommon from "../../Components/Common/PaperCommon";
import ErrorHandler, {
    calculateAgeAndMonth,
    formattedDate,
    getFileIcon,
    getLabelbyId,
    getValuebyId,
} from "../../Utils/handler";
import CloseIcon from '@mui/icons-material/Close';
import UploadDocuments from "../../Components/PagesComponents/UploadDocuments/UploadDocuments";
import PersonalDetails from "../../Components/PagesComponents/PersonalDetails";
import VerifyDetails from "../../Components/PagesComponents/VerifyDetails";
import { useDispatch } from "react-redux";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {
    aadhar_send_otp,
    aadhar_verify_otp,
    addMember,
    api_config,
    deleteFaqs,
    deleteFile,
    getAvailableAccess,
    getForm,
    getLocationByPincode,
    getMember,
    getMemberByPhoneNumber,
    getOccupation,
    updateMember,
    uploadImage,
} from "../../Redux/Actions/action";
import { showLoader } from "../../Redux/Slices/loaderSlice";
import {
    additionalDocumentTypeList,
    addMemberEnum,
    addressProofTypes,
    castTypes,
    idProofTypes,
    relationList,
} from "../../Utils/enum";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router";
import Payment from "../../Components/PagesComponents/Payment";
import { useSelector } from "react-redux";
import SkeletonLoader from "../../Components/Common/Skeleton";
import sessionStoreUtil from "../../ApiSetup/Localstorage";
import {
    dynamicGeneralDetails,
    dynamicNomineeDetails,
    dynamicPersonalDetails,
} from "./controller";
import CommonTextField from "../../Components/Common/CommonTextField";
import TextLabel from "../../Components/Common/CommonTextLabel";
import ButtonContained from "../../Components/Common/ButtonContained";
import { makeStyles } from "tss-react/mui";
import { BucketURL } from "../../ApiSetup/Api";
import DocPreview from "../../Components/Common/DocPreview";
import ButtonOutlined from "../../Components/Common/ButtonOutlined";
// TabPanel Component

const getTabStyle = (isActive) => ({
    justifyContent: "flex-start",
    textTransform: "none",
    fontWeight: isActive ? "bold" : "normal",
    color: isActive ? "#3E4094" : "inherit",
    border: "1px solid #3E4094",
    borderRadius: "20px",
    backgroundColor: isActive ? "#3E40941A" : "#FFFFFF",
    minWidth: "200px",
    minHeight: { xs: "40px", md: "50px" },
});

const useStyles = makeStyles()((theme) => {
    return {
        gridBorder: {
            background: "#fff",
            border: "1px solid #e8e8e8",
            padding: "24px",
            borderRadius: "16px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
        },
        label: {
            fontSize: "12px",
            fontWeight: 500,
            color: "#888",
            marginBottom: "6px",
            textTransform: "uppercase",
            letterSpacing: "0.3px",
        },
        TabList: {
            color: "#FFFFFF !important",
            "& .MuiTabs-indicator": {
                display: "none",
            },
            "& .Mui-selected": {
                // backgroundColor: "#3E4094",
                color: "#FFFFFF !important",
                borderBottom: "3px solid white",
                // backgroundColor: "#3E4094",
                // borderRadius: "6px"
            },
            // "& .MuiTabs-flexContainer": {
            //     display: "flex",
            //     justifyContent: "space-between",
            // },
            // "& .MuiTab-root": {
            //     color: "#FFFFFF !important",
            //     textTransform: "capitalize",
            //     flex: 1,
            //     borderRight: "1px solid #3E4094",
            //     ":last-of-type": {
            //         // borderRight: "none",
            //         borderRadius: "0 6px 6px 0"
            //     },
            //     ":first-of-type": {
            //         borderRadius: "6px 0 0 6px",
            //     },
            //     "&.Mui-selected:first-of-type": {
            //         borderRadius: "6px 0 0 6px",
            //     },
            //     display: "flex",
            //     alignItems: "center",
            //     gap: "8px",
            // },
        },
        TabDesign: {
            backgroundColor: "transparent",
            borderRadius: "6px",
            color: "#3E4094",
            minHeight: "40px",
            maxHeight: "50px",
            minWidth: "auto",
            "&.Mui-selected": {
                backgroundColor: "#3E4094",
            },
        },
    };
});

const Index = () => {
    // ---------- Hook -----------
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { classes } = useStyles();
    const theme = useTheme()
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id"); // gets the id
    const tabVal = queryParams.get("tabValue"); // gets the id
    const memberEdit = queryParams.get("memberEdit"); // gets the memberEdit
    const isEdit = queryParams.get("isEdit"); // gets the memberEdit
    const step = parseInt(queryParams.get("step") || "0", 10);

    const user = sessionStoreUtil.getLSItem("userData")
        ? JSON.parse(sessionStoreUtil.getLSItem("userData"))
        : {};

    // --------------- State -------------
    const [tab, setTab] = useState(step ? step : 1);

    const [documentTab, setDocumentTab] = React.useState(1);
    const [occupationList, setOccupationList] = useState();
    const [error, setError] = useState({});
    const [errors, setErrors] = useState({});
    const [sectionList, setSectionList] = useState([]);
    const [isAadhaarVerify, setIsAadhaarVerify] = useState(id ? true : false);
    const [isAadhaarNotVerify, setIsAadhaarNotVerify] = useState(false);
    const [isAddharEnter, seIsAddharEnter] = useState(false);
    const [aadharResponse, setAadharResponse] = useState(null);
    const [isIDProofVerify, setIsIDProofVerify] = useState(false);
    const [aadhaarEVerification, setAadhaarEVerification] = useState(false);
    const [preview, setPreview] = React.useState({ open: false, link: "", fileName: "" });
    const personals = sectionList?.[0]?.personalDetails?.fields || [];
    const idProof = sectionList?.[0]?.idProofDetails?.fields || [];
    const nominees = sectionList?.[0]?.nomineeDetails?.fields || [];
    const address = sectionList?.[0]?.addressDetails?.fields || [];
    const addressProof = sectionList?.[0]?.addressProofDetails?.fields || [];
    const village = sectionList?.[0]?.villageDetails?.fields || [];
    const other = sectionList?.[0]?.otherDetails?.fields || [];
    const additionalDocument = sectionList?.[0]?.additionalDocumentDetails?.fields || [];

    const [data, setData] = useState({});
    const personalDetails = dynamicPersonalDetails(personals, data);
    const idProofDetails = dynamicGeneralDetails(idProof, data);
    const nomineeDetails = dynamicNomineeDetails(nominees, data, relationList);


    const tabs = [
        {
            label: "Personal Details",
            icon: <PersonIcon />,
            content: "Content for Personal Details",
        },
        {
            label: "Upload Documents",
            icon: <UploadFileIcon />,
            content: "Content for Upload Documents",
            disabled: !id ? true : false,
        },
        {
            label: "Verify Details",
            icon: <SearchIcon />,
            content: "Content for Verify Details",
            disabled: !id ? true : false,
        },
        // { label: "Payment", icon: <PaymentIcon />, content: "Content for Payment", disabled: !id ? true : false },
    ];

    // --------------- handleChange ---------------
    const handleTabChange = (e, newValue) => {
        setTab(newValue);
        if (id) {
            navigate(`?id=${id}&step=${newValue + 1}`, { replace: true });
        }
    };

    const handleAddNominee = () => {
        setData((prevState) => {
            return {
                ...prevState,
                nomineeDetails: [
                    ...prevState.nomineeDetails,
                    { nomineeName: "", relation: "", contactNumber: "" },
                ],
            };
        });
    };

    const handleDeleteNominee = (index) => {
        setData((prevState) => {
            const updatedNomineeDetails = prevState.nomineeDetails.filter(
                (_, i) => i !== index
            );
            return {
                ...prevState,
                nomineeDetails: updatedNomineeDetails,
            };
        });
    };

    const _getMemberByPhoneNumber = async (no) => {
        dispatch(showLoader(true));
        try {
            const result = await dispatch(getMemberByPhoneNumber({ phoneNumber: no }));
            const error = ErrorHandler(result);
            if (error) {
                if (result?.payload?.data?.response) {
                    navigate(`/admin/addMember?id=${result?.payload?.data?.response?._id}&tabValue=${0}&step=0&isEdit=${true}`)
                } else {
                    navigate(`/admin/addMember`);
                    setData({
                    phoneNumber: no,
                    isSameAddress: true,
                    personalDetails: {
                        phoneNumber: no
                    },
                    idProofDetails: {},
                    nomineeDetails: [{
                        nomineeName: "",
                        relation: "",
                        contactNumber: "",
                    }],
                    addressDetails: {},
                    addressProofDetails: {},
                    villageDetails: {},
                    otherDetails: {},
                    additionalDocumentDetails: {},
                    uploadDocuments: {
                        aadharCard: {
                            frontSide: [],
                            backSide: [],
                            aadharNumber: [],
                            fullName: "",
                            dob: null,
                            address: "",
                        },
                        idProof: { idProofImage: "", idProofType: "" },
                        lc_dob_certificate: { image: "", cast: "", birthPlace: "" },
                        addressProof: { addressProofFile: "", addressProofType: "" },
                        additionalDocument: {
                            additionalDocumentType: "",
                            additionalDocumentFile: "",
                        },
                    },
                    })
                }
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    };

    const handleChange = async (e, parentKey, index) => {

        const { name, value } = e.target;
        let numberLimit;

        if (name === "aadhaarNumber") {
            numberLimit = 12;
        } else if (name === "referenceContactNumber") {
            numberLimit = 10;
        } else if (name === "phoneNumber") {
            numberLimit = 10;
        } else if (name === "contactNumber") {
            numberLimit = 10;
        } else if (name === "pinCode") {
            numberLimit = 6;
        } else if (name === "otp") {
            numberLimit = 6;
        } else if (name === "percentage") {
            numberLimit = 3;
        }

        if (
            numberLimit &&
            (!/^\d*$/.test(value) ||
                value.length > numberLimit ||
                (name === "percentage" && Number(value) > 100))
        ) {
            return;
        }

        if (name === "presentPinCode" && value?.length === 6) {
            setTimeout(async () => {
                try {
                    const body = { pincode: value };
                    const result = await dispatch(getLocationByPincode(body));
                    const error = ErrorHandler(result);
                    if (error) {
                        const data = result?.payload?.data?.response;
                        setErrors({ ...errors, ["addressProofDetails.validPinCode"]: "" });
                        setData((prevData) => {
                            const existingDetails = prevData["addressProofDetails"] || {};
                            return {
                                ...prevData,
                                ["addressProofDetails"]: {
                                    ...existingDetails,
                                    presentCity: data?.city,
                                    presentState: data?.state,
                                    presentCountry: data?.country,
                                },
                            };
                        });
                    } else {
                        setErrors({
                            ...errors,
                            ["addressProofDetails.validPinCode"]:
                                "Currently, we are only working for surat residents",
                        });
                        setData((prevData) => {
                            const existingDetails = prevData["addressProofDetails"] || {};
                            return {
                                ...prevData,
                                ["addressProofDetails"]: {
                                    ...existingDetails,
                                    presentCity: "",
                                    presentState: "",
                                    presentCountry: "",
                                },
                            };
                        });
                    }
                } catch (error) {
                    console.error("Error validating pincode:", error);
                }
            }, 100);
        }

        setData((prevState) => {
            if (parentKey === "nomineeDetails" && index !== undefined) {
                const updatedDetails = [...prevState.nomineeDetails];
                updatedDetails[index] = { ...updatedDetails[index], [name]: value };
                return { ...prevState, [parentKey]: updatedDetails };
            }

            return {
                ...prevState,
                [parentKey]: {
                    ...prevState[parentKey],
                    [name]: value,
                },
            };
        });
        if (name === "idProofType" || name === "idProofValue") {
            setIsIDProofVerify(false)
        }

        if (name === "phoneNumber" && value?.length === 10) {
            _getMemberByPhoneNumber(value)
        }
    };

    const handleFilterChange = (date, { target: { name } }, parentKey, index) => {
        if (
            (parentKey === "nomineeDetails" || parentKey === "personalDetails") &&
            index !== undefined
        ) {
            setData((prevData) => {
                const updatedDetails = [...prevData[parentKey]];
                updatedDetails[index] = {
                    ...updatedDetails[index],
                    [name]: dayjs(date).format("DD/MM/YYYY"),
                };
                return {
                    ...prevData,
                    [parentKey]: updatedDetails,
                };
            });
        } else {
            setData((prevData) => {
                // Ensure the parentKey exists and is initialized to an object
                const existingDetails = prevData[parentKey] || {};
                return {
                    ...prevData,
                    [parentKey]: {
                        ...existingDetails,
                        [name]: date, // Update the specific field
                    },
                };
            });
        }
    };

    // ------ validation ----
    const validation = () => {
        let isValid = true;
        let error = {};
        setError(error);
        return isValid;
    };

    // -------------- API calling ---------------------------------------
    const _getMember = async () => {
        dispatch(showLoader(true));
        try {
            const result = await dispatch(getMember(`/${id}`));
            const error = ErrorHandler(result);
            if (error) {
                const {
                    isFinalize,
                    userCurrentStep,
                    userDocumentsStep,
                    verificationStatus,
                    phoneNumber,
                    personalDetails,
                    idProofDetails,
                    nomineeDetails,
                    uploadDocuments,
                } = result?.payload?.data?.response;
                const formattedPersonalDetails = {};
                const formattedGeneralDetails = {};
                const formattedNomineeDetails = [];

                const personals = sectionList?.[0]?.personalDetails?.fields || [];
                const idProof = sectionList?.[0]?.idProofDetails?.fields || [];
                const nominees = sectionList?.[0]?.nomineeDetails?.fields || [];

                personals.forEach((field) => {
                    const { fieldKey, defineActionType } = field;
                    const fieldValue = personalDetails?.[fieldKey];

                    if (defineActionType === "date" && fieldValue) {
                        formattedPersonalDetails[fieldKey] = formattedDate(fieldValue);
                    } else if (defineActionType === "number" && fieldValue) {
                        formattedPersonalDetails[fieldKey] = +fieldValue || "";
                    } else {
                        formattedPersonalDetails[fieldKey] = fieldValue || "";
                    }
                });

                idProof.forEach((field) => {
                    const { fieldKey, defineActionType } = field;
                    const fieldValue = idProofDetails?.[fieldKey];

                    if (defineActionType === "date" && fieldValue) {
                        formattedGeneralDetails[fieldKey] = formattedDate(fieldValue);
                    } else if (defineActionType === "number" && fieldValue) {
                        formattedGeneralDetails[fieldKey] = +fieldValue || "";
                    } else {
                        formattedGeneralDetails[fieldKey] = fieldValue || "";
                    }
                });

                if (nominees.length > 0) {
                    nomineeDetails?.forEach((nominee) => {
                        const formattedNominee = { ...nominee };
                        nominees.forEach((field) => {
                            const { fieldKey, defineActionType } = field;
                            const fieldValue = nominee?.[fieldKey];

                            if (defineActionType === "date" && fieldValue) {
                                formattedNominee[fieldKey] = formattedDate(fieldValue);
                            } else if (fieldKey === "relation" && fieldValue) {
                                formattedNominee[fieldKey] = getLabelbyId(
                                    fieldValue,
                                    relationList
                                );
                            } else if (defineActionType === "number" && fieldValue) {
                                formattedNominee[fieldKey] = +fieldValue || "";
                            } else if (defineActionType === "text" && fieldValue) {
                                formattedNominee[fieldKey] = fieldValue;
                            } else {
                                formattedNominee[fieldKey] = fieldValue || "";
                            }
                        });
                        formattedNomineeDetails.push(formattedNominee);
                    });
                } else {
                    formattedNomineeDetails.push({
                        nomineeName: "",
                        relation: "",
                        contactNumber: "",
                    });
                }

                setData({
                    ...data,
                    phoneNumber: phoneNumber,
                    nomineeDetails: formattedNomineeDetails,
                    ...result?.payload?.data?.response,
                    isSameAddress: result?.payload?.data?.response?.isAddressSameAsAadhaar,
                    personalDetails: {
                        ...result?.payload?.data?.response?.personalDetails,
                        dateOfBirth: dayjs(result?.payload?.data?.response?.personalDetails?.dateOfBirth),
                        gender: result?.payload?.data?.response?.personalDetails?.gender?.toLowerCase() === "male" ? "Male" : result?.payload?.data?.response?.personalDetails?.gender?.toLowerCase() === "female" ? "Female" : ""
                    },
                    additionalDocumentDetails: result?.payload?.data?.response?.additionalDocuments
                });
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    };

    const _addUpdateMember = async (step) => {
        if (validation()) {
            try {
                let body = {
                    phoneNumber: data?.personalDetails?.phoneNumber,
                    personalDetails: { ...data?.personalDetails, dateOfBirth: dayjs(data?.personalDetails?.dateOfBirth).format("YYYY-MM-DD") },
                    idProofDetails: { ...data?.idProofDetails, idProofValue: data?.idProofDetails?.idProofValue?.toUpperCase() },
                    addressDetails: data?.addressDetails,
                    addressProofDetails: data?.addressProofDetails,
                    otherDetails: data?.otherDetails,
                    villageDetails: data?.villageDetails,
                    nomineeDetails: data?.nomineeDetails,
                    additionalDocuments: data?.additionalDocumentDetails,
                    userType: "User",
                    isIdProofVerified: isIDProofVerify,
                    isAddressSameAsAadhaar: data?.isSameAddress,
                    isAadhaarVerified: isAadhaarNotVerify || isAadhaarVerify,
                    userCurrentStep: memberEdit ? 3 : step,
                    // userDetailsStep: 3,
                    verificationStatus: memberEdit ? data?.verificationStatus : step === 2 ? "Draft" : user?.organisationName == "PPSK" ? "Approved" : "Pending",
                    isFinalize: memberEdit ? true : step === 3 ? true : false,
                    documentVerificationStatus: {
                        aadharCard: { status: "Approved", reason: "" },
                        idProof: { status: "Approved", reason: "" },
                        lc_dob_certificate: { status: "Approved", reason: "" },
                        addressProof: { status: "Approved", reason: "" },
                        additionalDocument: { status: "Approved", reason: "" },
                        isAgree: true,
                        verifiedBy: user?._id,
                    },
                    eSignVerifyUser: aadhaarEVerification
                };
                // if (step == 3 && data?.personalDetails?.role !== "User") {
                //     body.documentVerificationStatus = {
                //         aadharCard: { status: "Approved", reason: "" },
                //         idProof: { status: "Approved", reason: "" },
                //         lc_dob_certificate: { status: "Approved", reason: "" },
                //         addressProof: { status: "Approved", reason: "" },
                //         additionalDocument: { status: "Approved", reason: "" },
                //         isAgree: true,
                //         verifiedBy: user?._id,
                //     };
                // }
                // if (memberEdit) {
                //     body.verificationStatus = data?.verificationStatus;
                // } else {
                //     if (body.isFinalize) {
                //         body.verificationStatus = "Pending";
                //     } else {
                //         body.verificationStatus = "Draft";
                //     }
                // }
                if (id) {
                    body._id = id;
                }
                const fn = id ? updateMember : addMember;

                // return
                // const fn = addMember
                const result = await dispatch(fn(body));
                const error = ErrorHandler(result);
                if (error) {
                    toast.success(result?.payload?.message);
                    setTab(step);

                    if (memberEdit || isEdit) {
                        navigate("/admin/documents");
                    } else {
                        navigate(`?id=${result?.payload?.data.response._id}&step=${step}`, {
                            replace: true,
                        });
                        if (step == 3) {
                            if (user?.organisationName !== "PPSK") {
                                navigate("/admin/view-member");
                            } else {
                                navigate("/admin/documents");
                            }
                        }
                    }
                }
            } catch (error) {
                toast.error(error?.message || "An unknown error occurred");
            }
        }
    };

    const _getTextFileds = async () => {
        dispatch(showLoader(true));
        try {
            const result = await dispatch(getForm());
            const error = ErrorHandler(result);
            if (error) {
                setSectionList([
                    {
                        personalDetails: result?.payload?.data?.sections?.find(
                            (e) => e?.sectionId == addMemberEnum.personalDetails
                        ),
                        idProofDetails: result?.payload?.data?.sections?.find(
                            (e) => e?.sectionId == addMemberEnum.idProofDetails
                        ),
                        addressDetails: result?.payload?.data?.sections?.find(
                            (e) => e?.sectionId == addMemberEnum.addressDetails
                        ),
                        addressProofDetails: result?.payload?.data?.sections?.find(
                            (e) => e?.sectionId == addMemberEnum.addressProofDetails
                        ),
                        villageDetails: result?.payload?.data?.sections?.find(
                            (e) => e?.sectionId == addMemberEnum.villageDetails
                        ),
                        otherDetails: result?.payload?.data?.sections?.find(
                            (e) => e?.sectionId == addMemberEnum.otherDetails
                        ),
                        nomineeDetails: result?.payload?.data?.sections?.find(
                            (e) => e?.sectionId == addMemberEnum.nomineeDetails
                        ),
                        additionalDocumentDetails: result?.payload?.data?.sections?.find(
                            (e) => e?.sectionId == addMemberEnum.additionalDetails
                        ),
                    },
                ]);
                const defaultPersonalDetails = personals.reduce((acc, field) => {
                    acc[field.fieldKey] = field.defineActionType === "dropdown" ? "" : "";
                    return acc;
                }, {});

                const defaultIdProofDetails = idProof.reduce((acc, field) => {
                    acc[field.fieldKey] = field.defineActionType === "dropdown" ? "" : "";
                    return acc;
                }, {});
                const defaultAddressDetails = address.reduce((acc, field) => {
                    acc[field.fieldKey] = field.defineActionType === "dropdown" ? "" : "";
                    return acc;
                }, {});
                const defaultAddressProofDetails = addressProof.reduce((acc, field) => {
                    acc[field.fieldKey] = field.defineActionType === "dropdown" ? "" : "";
                    return acc;
                }, {});
                const defaultVillageDetails = village.reduce((acc, field) => {
                    acc[field.fieldKey] = field.defineActionType === "dropdown" ? "" : "";
                    return acc;
                }, {});
                const defaultOtherDetails = other.reduce((acc, field) => {
                    acc[field.fieldKey] = field.defineActionType === "dropdown" ? "" : "";
                    return acc;
                }, {});
                const defaultAdditionalDocumentDetails = additionalDocument.reduce((acc, field) => {
                    acc[field.fieldKey] = field.defineActionType === "dropdown" ? "" : "";
                    return acc;
                }, {});
                const defaultNomineeDetails =
                    nominees.length > 0
                        ? nominees.map(() => {
                            return nominees.reduce((acc, field) => {
                                acc[field.fieldKey] = "";
                                return acc;
                            }, {});
                        })
                        : [{ relation: "", nomineeName: "", contactNumber: "" }];

                setData({
                    phoneNumber: "",
                    isSameAddress: true,
                    personalDetails: defaultPersonalDetails,
                    idProofDetails: defaultIdProofDetails,
                    nomineeDetails: defaultNomineeDetails,
                    addressDetails: defaultAddressDetails,
                    addressProofDetails: defaultAddressProofDetails,
                    villageDetails: defaultVillageDetails,
                    otherDetails: defaultOtherDetails,
                    additionalDocumentDetails: defaultAdditionalDocumentDetails,
                    uploadDocuments: {
                        aadharCard: {
                            frontSide: [],
                            backSide: [],
                            aadharNumber: [],
                            fullName: "",
                            dob: null,
                            address: "",
                        },
                        idProof: { idProofImage: "", idProofType: "" },
                        lc_dob_certificate: { image: "", cast: "", birthPlace: "" },
                        addressProof: { addressProofFile: "", addressProofType: "" },
                        additionalDocument: {
                            additionalDocumentType: "",
                            additionalDocumentFile: "",
                        },
                    },
                });
            }
        } catch (error) {
        } finally {
            dispatch(showLoader(false));
        }
    };

    // const _getLocationByPincode = async (body) => {
    //     // dispatch(showLoader(true));
    //     try {
    //         const result = await dispatch(getLocationByPincode(body));
    //         const error = ErrorHandler(result);
    //         if (error) {
    //             return result.payload;
    //         }
    //     } catch (error) {
    //         console.error("API Error:", error);
    //     } finally {
    //         // dispatch(showLoader(false));
    //     }
    // };

    const handleUpload = async (e, parentKey, childKey = null) => {
        const { files, name } = e?.target;

        if (!files || files?.length === 0) {
            toast?.error("No files selected for upload.");
            return;
        }

        const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"]; // Including webp if supported
        const maxFileSize = 5242880; // 5 MB
        const invalidFiles = [];

        // Validate files
        for (let file of files) {
            if (!validTypes?.includes(file?.type) || file?.size > maxFileSize) {
                invalidFiles?.push(file?.name);
            }
        }

        if (invalidFiles.length > 0) {
            toast?.error(`Invalid files detected: ${invalidFiles?.join(", ")}.`);
            return;
        }

        dispatch(showLoader(true));

        try {
            const formData = new FormData();
            // Append all valid files
            Array.from(files)?.forEach((file) => formData?.append("image", file));

            // Dispatch single API call for multiple files
            const result = await dispatch(uploadImage(formData));

            // Handle response
            const error = ErrorHandler(result);
            const uploadedImages = error ? result?.payload?.data : null;
            if (uploadedImages && uploadedImages?.length > 0) {
                // Update state with all uploaded images
                setData((prevState) => {
                    const currentImages = childKey
                        ? prevState[parentKey][childKey][name] || []
                        : prevState[parentKey][name] || [];

                    // const newImages = [...currentImages, ...uploadedImages?.map(img => img?.image)];
                    const newImages = [...uploadedImages?.map((img) => img?.image)];

                    if (childKey) {
                        return {
                            ...prevState,
                            [parentKey]: {
                                ...prevState[parentKey],
                                [childKey]: {
                                    ...prevState[parentKey][childKey],
                                    [name]: newImages,
                                },
                            },
                        };
                    } else {
                        return {
                            ...prevState,
                            [parentKey]: {
                                ...prevState[parentKey],
                                [name]: newImages,
                            },
                        };
                    }
                });
            } else {
                toast?.error("No files were successfully uploaded.");
            }
        } catch (error) {
            console.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    };

    const handledelete = async (url) => {
        const body = { url: url };
        dispatch(showLoader(true));
        try {
            const result = await dispatch(deleteFile(body));
            const error = ErrorHandler(result);
            if (error) {
                toast?.success("Image Delete Successfully");
                setData({
                    ...data,
                    personalDetails: {
                        ...data?.personalDetails,
                        image: "",
                    },
                });
            }
        } catch (error) {
            console.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    };

    const _getOccupation = async () => {
        dispatch(showLoader(true));
        let body = {};
        try {
            const result = await dispatch(getOccupation(body));
            const error = ErrorHandler(result);
            if (error) {
                const occupationName = result?.payload?.data?.response?.map((e) => ({
                    label: e.occupation,
                    value: e.occupation,
                }));
                setOccupationList(occupationName);
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false));
        }
    };

    const aadhaValidation = () => {
        let isValid = true;
        if (!data?.personalDetails?.aadhaarNumber) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                aadhaarNumber: `Aadhaar Number (આધાર નંબર) is mandatory !`,
            }));
            isValid = false;
        }

        return isValid;
    }

    const _aadhar_send_otp = async () => {
        if (aadhaValidation()) {
            const body = { aadharNumber: data?.personalDetails?.aadhaarNumber };
            dispatch(showLoader(true));
            try {
                const result = await dispatch(aadhar_send_otp(body));
                const error = ErrorHandler(result);
                if (error) {
                    toast?.success(result?.payload?.data?.response?.data?.message);
                    seIsAddharEnter(true)
                    setAadharResponse(result?.payload?.data?.response)
                }
            } catch (error) {
                console.error(error);
            } finally {
                dispatch(showLoader(false));
            }
        }
    };


    const otpValidation = () => {
        let isValid = true;
        if (!data?.otp) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                otp: `OTP is mandatory !`,
            }));
            isValid = false;
        }

        return isValid;
    }

    const _aadhar_verify_otp = async () => {
        if (otpValidation()) {
            const body = { otp: data?.otp, transaction_id: aadharResponse?.transaction_id, aadharNumber: data?.personalDetails?.aadhaarNumber };
            dispatch(showLoader(true));
            try {
                const result = await dispatch(aadhar_verify_otp(body));
                const error = ErrorHandler(result);
                if (error) {
                    toast?.success(result?.payload?.message);
                    setIsAadhaarVerify(true)
                    const aadhaar_data = result?.payload?.data?.response?.data?.aadhaar_data
                    setData({
                        ...data,
                        personalDetails: {
                            ...data?.personalDetails,
                            fullName: aadhaar_data?.name,
                            dateOfBirth: dayjs(aadhaar_data?.date_of_birth),
                            gender: aadhaar_data?.gender?.toLowerCase() === "male" ? "Male" : aadhaar_data?.gender?.toLowerCase() === "female" ? "Female" : "",
                        },
                        addressDetails: {
                            aadhaarAddress: aadhaar_data?.house && aadhaar_data?.care_of && aadhaar_data?.street ? aadhaar_data?.house + aadhaar_data?.care_of + aadhaar_data?.street : aadhaar_data?.house && aadhaar_data?.care_of ? aadhaar_data?.house + aadhaar_data?.care_of : aadhaar_data?.house && aadhaar_data?.street ? aadhaar_data?.house + aadhaar_data?.street : aadhaar_data?.house || aadhaar_data?.care_of || aadhaar_data?.street || "",
                            landmark: aadhaar_data?.locality && aadhaar_data?.landmark ? aadhaar_data?.landmark + aadhaar_data?.locality : aadhaar_data?.landmark || aadhaar_data?.locality || "",
                            area: aadhaar_data?.post_office_name,
                            pincode: aadhaar_data?.pincode,
                            city: aadhaar_data?.district,
                            state: aadhaar_data?.state,
                            country: aadhaar_data?.country
                        },
                        isSameAddress: aadhaar_data?.isAddressSameAsAadhaar,
                        isAadhaarVerified: aadhaar_data?.isAadhaarVerified
                    })
                }
            } catch (error) {
                console.error(error);
            } finally {
                dispatch(showLoader(false));
            }
        }
    };

    const _api_config = async () => {
        dispatch(showLoader(true))
        try {
            const result = await dispatch(api_config());
            const error = ErrorHandler(result);
            if (error) {
                setAadhaarEVerification(result?.payload?.data?.response?.aadhaarEVerification)
            }
        } catch (error) {
            toast.error(error);
        } finally {
            dispatch(showLoader(false))
        }
    }

    useEffect(() => {
        _api_config()
    }, [])

    // ---------------- useEffect ----------------
    useEffect(() => {
        _getTextFileds();
        _getOccupation();
    }, []);

    useEffect(() => {
        if (id && sectionList?.length > 0) {
            _getMember();
        }
    }, [id, sectionList]);

    useEffect(() => {
        dispatch(showLoader(true));
        dispatch(getAvailableAccess())
            .unwrap() // Automatically handles async response
            .catch((error) => console.error("error", error))
            .finally(() => dispatch(showLoader(false)));
    }, [dispatch]);

    return (
        <>
            <Grid container spacing={1}>
                {/* Tab Panels Section */}
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <PaperCommon
                        padding={"0px 5px 15px 20px"}
                        contant={
                            <>
                                {aadhaarEVerification && !isAadhaarVerify && !isAadhaarNotVerify ? (
                                    <>
                                        <Grid container item xs={12} spacing={2} mb={1}>
                                            <Grid item xs={12} display={"flex"} justifyContent={'space-between'} alignItems={"center"} gap={1} >
                                                <TextLabel fontWeight={600} fontSize={{ xs: "16px", md: "20px" }} title={"Verify Aadhaar Number"} />
                                            </Grid>
                                        </Grid>
                                        <Divider />
                                        <Grid container spacing={2} item xs={12} lg={12} md={12} mt={0}>
                                            <Grid item lg={6} md={6} xs={12}>
                                                <CommonTextField
                                                    text={"Aadhaar Number (આધાર નંબર)"}
                                                    type={"number"}
                                                    placeholder={`Enter Aadhaar Number (આધાર નંબર)`}
                                                    name={"aadhaarNumber"}
                                                    width="100%"
                                                    value={data?.personalDetails?.aadhaarNumber}
                                                    valid={true}
                                                    onChange={(e) => handleChange(e, "personalDetails")}
                                                    disabled={isAddharEnter}
                                                />
                                                <TextLabel
                                                    color="error"
                                                    title={!data?.personalDetails?.aadhaarNumber ? errors?.aadhaarNumber : ""}
                                                />
                                            </Grid>
                                            {isAddharEnter &&
                                                <Grid item lg={6} md={6} xs={12}>
                                                    <CommonTextField
                                                        value={data?.otp}
                                                        width={"100%"}
                                                        text="OTP"
                                                        type="number"
                                                        placeholder="Enter OTP"
                                                        name="otp"
                                                        valid
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            if (/^(?!0{2,})\d{0,6}$/.test(value) && value.length <= 6) {
                                                                setData((prevValue) => ({
                                                                    ...prevValue,
                                                                    otp: value,
                                                                }));
                                                            }
                                                        }}
                                                    />
                                                    <TextLabel color="error" title={!data?.otp ? errors.otp : ""} />
                                                </Grid>
                                            }
                                            <Grid item lg={isAddharEnter ? 12 : 6} md={isAddharEnter ? 12 : 6} xs={12} mt={{ lg: isAddharEnter ? 1 : 2.5, md: isAddharEnter ? 1 : 2.5, sm: 1, xs: 1 }} sx={{ textAlign: { lg: isAddharEnter ? "end" : 'start', md: isAddharEnter ? "end" : "start", sm: 'end', xs: "end" } }}>
                                                <ButtonContained
                                                    width={"auto"}
                                                    text={isAddharEnter ? "Verify OTP" : "Send OTP"}
                                                    lineHeight={"24.5px"}
                                                    padding={{ xs: "5px 10px", md: "10px 20px" }}
                                                    fontSize={{ xs: "12px", md: "14px" }}
                                                    height={{ xs: "40px", sm: "40px" }}
                                                    onClick={() => {
                                                        if (isAddharEnter) {
                                                            _aadhar_verify_otp()
                                                        } else {
                                                            _aadhar_send_otp()
                                                        }
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </>
                                ) :
                                    <>
                                        {sectionList?.length > 0 ? (
                                            <>
                                                {/* Personal Details */}
                                                {tab === 1 && (
                                                    <PersonalDetails
                                                        sectionList={sectionList}
                                                        setSectionList={setSectionList}
                                                        data={data}
                                                        setData={setData}
                                                        handleChange={handleChange}
                                                        handleFilterChange={handleFilterChange}
                                                        _addUpdateMember={_addUpdateMember}
                                                        handleUpload={handleUpload}
                                                        error={error}
                                                        setErrors={setErrors}
                                                        errors={errors}
                                                        handleAddNominee={handleAddNominee}
                                                        handleDeleteNominee={handleDeleteNominee}
                                                        id={id}
                                                        occupationList={occupationList}
                                                        handledelete={handledelete}
                                                        tabVal={tabVal}
                                                        memberEdit={memberEdit}
                                                        setIsIDProofVerify={setIsIDProofVerify}
                                                        isIDProofVerify={isIDProofVerify}
                                                        aadhaarEVerification={aadhaarEVerification}
                                                    />
                                                )}


                                            </>
                                        ) : (
                                            <SkeletonLoader />
                                        )}
                                        {tab === 2 && (
                                            <Box p={2}>
                                                {/* Header */}
                                                <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                    <TextLabel fontWeight={600} fontSize={{ xs: "18px", md: "22px" }} title={"Review & Verify Details"} />
                                                </Box>

                                                {/* Profile Summary Card */}
                                                <Box sx={{ 
                                                    background: 'linear-gradient(135deg, #3E4094 0%, #5a5cb8 100%)', 
                                                    borderRadius: '20px', 
                                                    p: 3, 
                                                    mb: 3,
                                                    color: '#fff'
                                                }}>
                                                    <Grid container spacing={3} alignItems="center">
                                                        <Grid item xs={12} sm="auto">
                                                            <Avatar 
                                                                src={BucketURL + (Array.isArray(data?.personalDetails?.image) ? data?.personalDetails?.image[0] : data?.personalDetails?.image)} 
                                                                alt="Profile" 
                                                                sx={{ 
                                                                    width: 100, 
                                                                    height: 100, 
                                                                    border: '4px solid rgba(255,255,255,0.3)',
                                                                    cursor: 'pointer',
                                                                    boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
                                                                }}
                                                                onClick={() => setPreview({ 
                                                                    open: true, 
                                                                    link: BucketURL + (Array.isArray(data?.personalDetails?.image) ? data?.personalDetails?.image[0] : data?.personalDetails?.image), 
                                                                    fileName: data?.personalDetails?.image 
                                                                })}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm>
                                                            <Typography variant="h5" fontWeight={600} gutterBottom>
                                                                {data?.personalDetails?.fullName || "N/A"}
                                                            </Typography>
                                                            <Box display="flex" flexWrap="wrap" gap={2} sx={{ opacity: 0.9 }}>
                                                                <Typography variant="body2">📱 {data?.personalDetails?.phoneNumber || "N/A"}</Typography>
                                                                <Typography variant="body2">🪪 {data?.personalDetails?.aadhaarNumber || "N/A"}</Typography>
                                                                <Typography variant="body2">🎂 {dayjs(data?.personalDetails?.dateOfBirth).format("DD MMM YYYY")}</Typography>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={12} sm="auto">
                                                            <Box display="flex" flexWrap="wrap" gap={1}>
                                                                <Box sx={{ px: 2, py: 0.5, borderRadius: '20px', bgcolor: 'rgba(255,255,255,0.2)', fontSize: '13px' }}>
                                                                    {data?.personalDetails?.gender || "N/A"}
                                                                </Box>
                                                                <Box sx={{ px: 2, py: 0.5, borderRadius: '20px', bgcolor: 'rgba(255,255,255,0.2)', fontSize: '13px' }}>
                                                                    {data?.personalDetails?.bloodGroup || "N/A"}
                                                                </Box>
                                                                <Box sx={{ px: 2, py: 0.5, borderRadius: '20px', bgcolor: 'rgba(255,255,255,0.2)', fontSize: '13px' }}>
                                                                    {data?.personalDetails?.maritalStatus || "N/A"}
                                                                </Box>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Box>

                                                {/* Aadhaar Documents */}
                                                {(data?.personalDetails?.aadhaarFrontSide || data?.personalDetails?.aadhaarBackSide) && (
                                                    <Box className={classes.gridBorder} sx={{ mb: 3 }}>
                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, pb: 2, borderBottom: '1px solid #eee' }}>
                                                            <Box sx={{ width: 36, height: 36, borderRadius: '10px', bgcolor: 'rgba(62,64,148,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                🪪
                                                            </Box>
                                                            <Typography fontWeight={600} color="#3E4094" fontSize="16px">Aadhaar Card</Typography>
                                                        </Box>
                                                        <Grid container spacing={3}>
                                                            {data?.personalDetails?.aadhaarFrontSide && (
                                                                <Grid item xs={12} sm={6}>
                                                                    <Box 
                                                                        sx={{ 
                                                                            border: '1px solid #e0e0e0', 
                                                                            borderRadius: '12px', 
                                                                            overflow: 'hidden',
                                                                            cursor: 'pointer',
                                                                            transition: 'all 0.2s',
                                                                            '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.1)', transform: 'translateY(-2px)' }
                                                                        }}
                                                                        onClick={() => setPreview({ 
                                                                            open: true, 
                                                                            link: BucketURL + (Array.isArray(data?.personalDetails?.aadhaarFrontSide) ? data?.personalDetails?.aadhaarFrontSide[0] : data?.personalDetails?.aadhaarFrontSide), 
                                                                            fileName: data?.personalDetails?.aadhaarFrontSide 
                                                                        })}
                                                                    >
                                                                        <Box 
                                                                            component="img"
                                                                            src={BucketURL + (Array.isArray(data?.personalDetails?.aadhaarFrontSide) ? data?.personalDetails?.aadhaarFrontSide[0] : data?.personalDetails?.aadhaarFrontSide)}
                                                                            alt="Aadhaar Front"
                                                                            sx={{ width: '100%', height: 160, objectFit: 'cover' }}
                                                                            onError={(e) => { e.target.src = '/images/placeholder.png'; }}
                                                                        />
                                                                        <Box sx={{ p: 1.5, bgcolor: '#3E4094', color: '#fff', textAlign: 'center' }}>
                                                                            <Typography variant="body2" fontWeight={500}>Front Side</Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </Grid>
                                                            )}
                                                            {data?.personalDetails?.aadhaarBackSide && (
                                                                <Grid item xs={12} sm={6}>
                                                                    <Box 
                                                                        sx={{ 
                                                                            border: '1px solid #e0e0e0', 
                                                                            borderRadius: '12px', 
                                                                            overflow: 'hidden',
                                                                            cursor: 'pointer',
                                                                            transition: 'all 0.2s',
                                                                            '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.1)', transform: 'translateY(-2px)' }
                                                                        }}
                                                                        onClick={() => setPreview({ 
                                                                            open: true, 
                                                                            link: BucketURL + (Array.isArray(data?.personalDetails?.aadhaarBackSide) ? data?.personalDetails?.aadhaarBackSide[0] : data?.personalDetails?.aadhaarBackSide), 
                                                                            fileName: data?.personalDetails?.aadhaarBackSide 
                                                                        })}
                                                                    >
                                                                        <Box 
                                                                            component="img"
                                                                            src={BucketURL + (Array.isArray(data?.personalDetails?.aadhaarBackSide) ? data?.personalDetails?.aadhaarBackSide[0] : data?.personalDetails?.aadhaarBackSide)}
                                                                            alt="Aadhaar Back"
                                                                            sx={{ width: '100%', height: 160, objectFit: 'cover' }}
                                                                            onError={(e) => { e.target.src = '/images/placeholder.png'; }}
                                                                        />
                                                                        <Box sx={{ p: 1.5, bgcolor: '#3E4094', color: '#fff', textAlign: 'center' }}>
                                                                            <Typography variant="body2" fontWeight={500}>Back Side</Typography>
                                                                        </Box>
                                                                    </Box>
                                                                </Grid>
                                                            )}
                                                        </Grid>
                                                    </Box>
                                                )}

                                                {/* Personal Details Grid */}
                                                <Box className={classes.gridBorder} sx={{ mb: 3 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, pb: 2, borderBottom: '1px solid #eee' }}>
                                                        <Box sx={{ width: 36, height: 36, borderRadius: '10px', bgcolor: 'rgba(62,64,148,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            👤
                                                        </Box>
                                                        <Typography fontWeight={600} color="#3E4094" fontSize="16px">Personal Information</Typography>
                                                    </Box>
                                                    <Grid container spacing={2}>
                                                        {[
                                                            { label: 'Full Name', value: data?.personalDetails?.fullName },
                                                            { label: 'Phone Number', value: data?.personalDetails?.phoneNumber },
                                                            { label: 'Aadhaar Number', value: data?.personalDetails?.aadhaarNumber },
                                                            { label: 'Date of Birth', value: dayjs(data?.personalDetails?.dateOfBirth).format("DD MMM YYYY") },
                                                            { label: 'Gender', value: data?.personalDetails?.gender },
                                                            { label: 'Blood Group', value: data?.personalDetails?.bloodGroup },
                                                            { label: 'Caste', value: data?.personalDetails?.caste },
                                                            { label: 'Marital Status', value: data?.personalDetails?.maritalStatus },
                                                            { label: 'Role', value: data?.personalDetails?.role },
                                                        ].map((item, idx) => (
                                                            <Grid item xs={6} sm={4} md={3} key={idx}>
                                                                <Box sx={{ p: 1.5, bgcolor: '#f8f9fa', borderRadius: '10px' }}>
                                                                    <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '11px' }}>
                                                                        {item.label}
                                                                    </Typography>
                                                                    <Typography variant="body2" fontWeight={500} sx={{ mt: 0.5 }}>
                                                                        {item.value || "N/A"}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                </Box>
                                                {/* ID Proof Section */}
                                                <Box className={classes.gridBorder} sx={{ mb: 3 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, pb: 2, borderBottom: '1px solid #eee' }}>
                                                        <Box sx={{ width: 36, height: 36, borderRadius: '10px', bgcolor: 'rgba(62,64,148,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            📄
                                                        </Box>
                                                        <Typography fontWeight={600} color="#3E4094" fontSize="16px">ID Proof Details</Typography>
                                                    </Box>
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={6} sm={4} md={3}>
                                                            <Box sx={{ p: 1.5, bgcolor: '#f8f9fa', borderRadius: '10px' }}>
                                                                <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '11px' }}>
                                                                    ID Proof Type
                                                                </Typography>
                                                                <Typography variant="body2" fontWeight={500} sx={{ mt: 0.5 }}>
                                                                    {data?.idProofDetails?.idProofType || "N/A"}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                        <Grid item xs={6} sm={4} md={3}>
                                                            <Box sx={{ p: 1.5, bgcolor: '#f8f9fa', borderRadius: '10px' }}>
                                                                <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '11px' }}>
                                                                    ID Proof Number
                                                                </Typography>
                                                                <Typography variant="body2" fontWeight={500} sx={{ mt: 0.5 }}>
                                                                    {data?.idProofDetails?.idProofValue || "N/A"}
                                                                </Typography>
                                                            </Box>
                                                        </Grid>
                                                        {isIDProofVerify && renderIDProof(data?.idProofDetails?.idProofType, data?.idProofDetails)}
                                                        {data?.idProofDetails?.idProofImage && (
                                                            <Grid item xs={12} sm={6} md={4}>
                                                                <Box 
                                                                    sx={{ 
                                                                        border: '1px solid #e0e0e0', 
                                                                        borderRadius: '12px', 
                                                                        overflow: 'hidden',
                                                                        cursor: 'pointer',
                                                                        transition: 'all 0.2s',
                                                                        '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.1)', transform: 'translateY(-2px)' }
                                                                    }}
                                                                    onClick={() => setPreview({ 
                                                                        open: true, 
                                                                        link: BucketURL + (Array.isArray(data?.idProofDetails?.idProofImage) ? data?.idProofDetails?.idProofImage[0] : data?.idProofDetails?.idProofImage), 
                                                                        fileName: data?.idProofDetails?.idProofImage 
                                                                    })}
                                                                >
                                                                    <Box 
                                                                        component="img"
                                                                        src={BucketURL + (Array.isArray(data?.idProofDetails?.idProofImage) ? data?.idProofDetails?.idProofImage[0] : data?.idProofDetails?.idProofImage)}
                                                                        alt="ID Proof"
                                                                        sx={{ width: '100%', height: 120, objectFit: 'cover' }}
                                                                        onError={(e) => { e.target.src = '/images/placeholder.png'; }}
                                                                    />
                                                                    <Box sx={{ p: 1, bgcolor: '#f5f5f5', textAlign: 'center' }}>
                                                                        <Typography variant="caption" fontWeight={500}>ID Proof Document</Typography>
                                                                    </Box>
                                                                </Box>
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                </Box>

                                                {/* Address Details Section */}
                                                <Box className={classes.gridBorder} sx={{ mb: 3 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, pb: 2, borderBottom: '1px solid #eee' }}>
                                                        <Box sx={{ width: 36, height: 36, borderRadius: '10px', bgcolor: 'rgba(62,64,148,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            🏠
                                                        </Box>
                                                        <Typography fontWeight={600} color="#3E4094" fontSize="16px">Address Details</Typography>
                                                    </Box>
                                                    <Grid container spacing={2}>
                                                        {[
                                                            { label: 'Aadhaar Address', value: data?.addressDetails?.aadhaarAddress, fullWidth: true },
                                                            { label: 'Landmark', value: data?.addressDetails?.landmark },
                                                            { label: 'Area', value: data?.addressDetails?.area },
                                                            { label: 'Pincode', value: data?.addressDetails?.pincode },
                                                            { label: 'City', value: data?.addressDetails?.city },
                                                            { label: 'State', value: data?.addressDetails?.state },
                                                            { label: 'Country', value: data?.addressDetails?.country },
                                                        ].map((item, idx) => (
                                                            <Grid item xs={item.fullWidth ? 12 : 6} sm={item.fullWidth ? 12 : 4} md={item.fullWidth ? 6 : 3} key={idx}>
                                                                <Box sx={{ p: 1.5, bgcolor: '#f8f9fa', borderRadius: '10px' }}>
                                                                    <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: '0.5px', fontSize: '11px' }}>
                                                                        {item.label}
                                                                    </Typography>
                                                                    <Typography variant="body2" fontWeight={500} sx={{ mt: 0.5 }}>
                                                                        {item.value || "N/A"}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                </Box>
                                                    {!data?.isSameAddress &&
                                                        <Grid container spacing={2} className={classes.gridBorder} mt={2}>
                                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                                <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"Address Proof Details"} />
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                                                <InputLabel className={classes.label}>Present Address Proof Type </InputLabel>
                                                                <Typography variant="body1">{data?.addressProofDetails?.presentAddressProofType || "N/A"}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                                                <InputLabel className={classes.label}>Upload Address Proof </InputLabel>
                                                                <Avatar src={BucketURL + data?.addressProofDetails?.uploadAddressProof?.[0]} alt="image" sx={{ cursor: 'pointer', border: '1px solid grey' }}
                                                                    slotProps={{
                                                                        loading: "lazy",
                                                                        cursor: 'pointer'
                                                                    }}
                                                                    onClick={() => setPreview({ open: true, link: BucketURL + data?.addressProofDetails?.uploadAddressProof?.[0], fileName: data?.addressProofDetails?.uploadAddressProof })}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                                                <InputLabel className={classes.label}>Aadhaar Address </InputLabel>
                                                                <Typography variant="body1">{data?.addressProofDetails?.presentAddress || "N/A"}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                                                <InputLabel className={classes.label}>Landmark </InputLabel>
                                                                <Typography variant="body1">{data?.addressProofDetails?.presentLandmark || "N/A"}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                                                <InputLabel className={classes.label}>Area </InputLabel>
                                                                <Typography variant="body1">{data?.addressProofDetails?.presentArea || "N/A"}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                                                <InputLabel className={classes.label}>Pincode </InputLabel>
                                                                <Typography variant="body1">{data?.addressProofDetails?.presentPinCode || "N/A"}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                                                <InputLabel className={classes.label}>City </InputLabel>
                                                                <Typography variant="body1">{data?.addressProofDetails?.presentCity || "N/A"}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                                                <InputLabel className={classes.label}>State </InputLabel>
                                                                <Typography variant="body1">{data?.addressProofDetails?.presentState || "N/A"}</Typography>
                                                            </Grid>
                                                            <Grid item xs={12} sm={6} md={4} lg={3}>
                                                                <InputLabel className={classes.label}>Country </InputLabel>
                                                                <Typography variant="body1">{data?.addressProofDetails?.presentCountry || "N/A"}</Typography>
                                                            </Grid>
                                                        </Grid>
                                                    }
                                                    <Grid container spacing={2} className={classes.gridBorder} mt={2}>
                                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                                            <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"Village Details"} />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4} lg={3}>
                                                            <InputLabel className={classes.label}>Village Name </InputLabel>
                                                            <Typography variant="body1">{data?.villageDetails?.villageName || "N/A"}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4} lg={3}>
                                                            <InputLabel className={classes.label}>Taluka </InputLabel>
                                                            <Typography variant="body1">{data?.villageDetails?.taluka || "N/A"}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4} lg={3}>
                                                            <InputLabel className={classes.label}>District </InputLabel>
                                                            <Typography variant="body1">{data?.villageDetails?.district || "N/A"}</Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={2} className={classes.gridBorder} mt={2}>
                                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                                            <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"Other Details"} />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4} lg={3}>
                                                            <InputLabel className={classes.label}>Reference Mobile No </InputLabel>
                                                            <Typography variant="body1">{data?.otherDetails?.referencePersonContactNumber || "N/A"}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4} lg={3}>
                                                            <InputLabel className={classes.label}>Education </InputLabel>
                                                            <Typography variant="body1">{data?.otherDetails?.education || "N/A"}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4} lg={3}>
                                                            <InputLabel className={classes.label}>Occupation </InputLabel>
                                                            <Typography variant="body1">{data?.otherDetails?.occupation || "N/A"}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4} lg={3}>
                                                            <InputLabel className={classes.label}>Company Name </InputLabel>
                                                            <Typography variant="body1">{data?.otherDetails?.companyName || "N/A"}</Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container spacing={2} className={classes.gridBorder} mt={2}>
                                                        {data?.nomineeDetails?.map((nominee, index) => (
                                                            <>
                                                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                                                    <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={`Nominee Detail (${index + 1})`} marginBottom={1} />
                                                                </Grid>
                                                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                                                    <InputLabel className={classes.label}>Relation</InputLabel>
                                                                    <Typography variant="body1">{nominee?.relation || "N/A"}</Typography>
                                                                </Grid>

                                                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                                                    <InputLabel className={classes.label}>Nominee</InputLabel>
                                                                    <Typography variant="body1">{nominee?.nomineeName || "N/A"}</Typography>
                                                                </Grid>
                                                                <Grid item xs={12} sm={6} md={4} lg={3}>
                                                                    <InputLabel className={classes.label}>Contact Number</InputLabel>
                                                                    <Typography variant="body1">{nominee?.contactNumber || "N/A"}</Typography>
                                                                </Grid>
                                                            </>
                                                        ))}
                                                    </Grid>
                                                    <Grid container spacing={2} className={classes.gridBorder} mt={2}>
                                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                                            <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"Address Proof Details"} />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4} lg={3}>
                                                            <InputLabel className={classes.label}>Additional Documents Type </InputLabel>
                                                            <Typography variant="body1">{data?.additionalDocuments?.additionalDocumentType || "N/A"}</Typography>
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4} lg={3}>
                                                            <InputLabel className={classes.label}>Additional Documents Proof </InputLabel>
                                                            <Avatar src={BucketURL + data?.additionalDocuments?.additionalDocumentProof?.[0]} alt="image" sx={{ cursor: 'pointer', border: '1px solid grey' }}
                                                                slotProps={{
                                                                    loading: "lazy",
                                                                    cursor: 'pointer'
                                                                }}
                                                                onClick={() => setPreview({ open: true, link: BucketURL + data?.additionalDocuments?.additionalDocumentProof?.[0], fileName: data?.additionalDocuments?.additionalDocumentProof })}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={6} md={4} lg={3}>
                                                            <InputLabel className={classes.label}>Description </InputLabel>
                                                            <Typography variant="body1">{data?.additionalDocuments?.description || "N/A"}</Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12} display={"flex"} gap={1} mt={2} justifyContent={"flex-end"} >
                                                        <ButtonOutlined
                                                            width={"auto"}
                                                            text={"Back"}
                                                            lineHeight={"24.5px"}
                                                            padding={{ xs: "5px 10px", md: "10px 20px" }}
                                                            fontSize={{ xs: "12px", md: "14px" }}
                                                            height={{ xs: "40px", sm: "40px" }}
                                                            startIcon={<ArrowBackIcon />}
                                                            onClick={() => {
                                                                // navigate("/admin/addMember");
                                                                setTab(1)
                                                            }}
                                                        />
                                                        <ButtonContained
                                                            width={"auto"}
                                                            text={"Submit"}
                                                            lineHeight={"24.5px"}
                                                            padding={{ xs: "5px 10px", md: "10px 20px" }}
                                                            fontSize={{ xs: "12px", md: "14px" }}
                                                            height={{ xs: "40px", sm: "40px" }}
                                                            onClick={() => {
                                                                _addUpdateMember(3);
                                                            }}
                                                        />
                                                    </Grid>
                                            </Box>
                                        )}
                                    </>}
                            </>
                        }
                    />
                </Grid>
            </Grid>
            {preview?.open && (
                <Dialog open={preview?.open} onClose={() => setPreview({ open: false, link: "", fileName: "" })} fullWidth={true}>
                    <DialogTitle sx={{ padding: "8px 16px" }}>
                        <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} >
                            <Typography fontSize={"15px"} fontWeight={700} color={theme.palette.primary.main}>
                                Preview
                            </Typography>
                            <Box display={'flex'} gap={1} justifyContent={'space-between'} alignItems={'center'} >
                                <CloseIcon onClick={() => setPreview({ open: false, link: "", fileName: "" })} style={{ cursor: 'pointer' }} />
                            </Box>
                        </Box>
                    </DialogTitle>

                    <DialogContent>
                        <DocPreview
                            link={preview?.link}
                            iconName={getFileIcon(preview?.fileName, preview?.fileName[0])}  // Passing originalDocArray and fileName
                            octateFile={false}
                        />
                    </DialogContent>

                </Dialog>
            )}
        </>
    );
};

const renderIDProof = (type, data) => {
    return (
        type === "PAN Card" ?
            <>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <InputLabel>Full Name</InputLabel>
                    <Typography variant="body1">{data?.name || "N/A"}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <InputLabel>Gender</InputLabel>
                    <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>{data?.gender || "N/A"}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <InputLabel>Date of Birth</InputLabel>
                    <Typography variant="body1">{data?.date_of_birth ? dayjs(data?.date_of_birth).format("DD MMM YYYY") : "N/A"}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <InputLabel>Masked Aadhaar Number</InputLabel>
                    <Typography variant="body1">{data?.masked_aadhaar_number || "N/A"}</Typography>
                </Grid>
            </>
            : type === "Voter ID Card" ?
                <>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <InputLabel>Full Name</InputLabel>
                        <Typography variant="body1">{data?.name || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <InputLabel>Father Name</InputLabel>
                        <Typography variant="body1">{data?.father_name || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <InputLabel>Gender</InputLabel>
                        <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>{data?.gender || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <InputLabel>Date of Birth</InputLabel>
                        <Typography variant="body1">{data?.date_of_birth ? dayjs(data?.date_of_birth).format("DD MMM YYYY") : "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <InputLabel>State</InputLabel>
                        <Typography variant="body1">{data?.state || "N/A"}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <InputLabel>District</InputLabel>
                        <Typography variant="body1">{data?.district || "N/A"}</Typography>
                    </Grid>
                </>
                : type === "Passport" ?
                    <>
                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <InputLabel>First Name</InputLabel>
                            <Typography variant="body1">{data?.first_name || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <InputLabel>Issue Date</InputLabel>
                            <Typography variant="body1">{data?.issue_date ? dayjs(data?.issue_date).format("DD MMM YYYY") : "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <InputLabel>Date of Birth</InputLabel>
                            <Typography variant="body1">{data?.date_of_birth ? dayjs(data?.date_of_birth).format("DD MMM YYYY") : "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={4}>
                            <InputLabel>document ID</InputLabel>
                            <Typography variant="body1">{data?.document_id || "N/A"}</Typography>
                        </Grid>
                    </>
                    :
                    <>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <InputLabel>Full Name</InputLabel>
                            <Typography variant="body1">{data?.name || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <InputLabel>Father Name</InputLabel>
                            <Typography variant="body1">{data?.dependent_name || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <InputLabel>Date of Birth</InputLabel>
                            <Typography variant="body1">{data?.date_of_birth ? dayjs(data?.date_of_birth).format("DD MMM YYYY") : "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <InputLabel>Address</InputLabel>
                            <Typography variant="body1">{data?.address || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <InputLabel>Pincode</InputLabel>
                            <Typography variant="body1">{data?.pincode || "N/A"}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <InputLabel>Blood Group</InputLabel>
                            <Typography variant="body1">{data?.blood_group || "N/A"}</Typography>
                        </Grid>
                    </>
    )
}


export default Index;
